<footer class="footer">
    <div class="footer-mb">
        <div class="footer-text">
            <span class="footer_mb_text">© {{calenderYear}} ConnectPay</span>
        </div>
        <div class="footer-text">
            <span class="footer_mb_link1"><a href="https://connectpay.com/support" target="_blank"> Support</a></span>
        </div>
        <div class="footer-text">
            <span class="footer_mb_link2"><a href="https://connectpay.com/privacy-policy" target="_blank">Privacy Policy</a></span>
        </div>
    </div>
    <div class="footer-nm">
        <div class="footer-left">
            <span class="footer-block footer_nm_text"> © {{calenderYear}} ConnectPay </span>
        </div>
        <div class="footer-right">
            <span class="footer-block footer_nm_link1"><a href="https://connectpay.com/support" target="_blank"> Support</a></span>
            <span class="footer-block pl-2 footer_nm_link2"><a href="https://connectpay.com/privacy-policy" target="_blank"> Privacy </a></span>   
        </div>
    </div>
  </footer>